import { FC } from 'react';
import { observer } from '~/modules';
import CreditSimulationConfirmation from './CreditSimulationConfirmation';

const CreditSimulationConfirmationContainer: FC = () => {
  return <CreditSimulationConfirmation />;
};

export default observer(CreditSimulationConfirmationContainer);
